import { Skeleton } from '@lifebit-ai/lds'
import React from 'react'

import * as styles from './FileActionsSkeleton.styles'

export const FILE_ACTIONS_SKELETON_TEST_ID = 'file-actions-skeleton'

const FileActionsSkeleton = (): JSX.Element => (
  <styles.Root aria-busy="true" aria-label="Loading file actions" data-testid={FILE_ACTIONS_SKELETON_TEST_ID}>
    <Skeleton.Avatar active shape="square" size="medium" />
  </styles.Root>
)

export default FileActionsSkeleton
